import { Badge } from '@/lib/base/badges/badges';

/**
 * Working label for the ad-hoc-meeting indicator. Sentence case (validated against
 * /ahoy-ux-copy - a derived state descriptor, same casing class as the "Summary"/"Meeting prep"
 * pills in meeting-series-section.tsx; NOT title case). Final copy is subject to /ahoy-ux-copy;
 * centralised here so it changes in one place.
 */
export const NOT_ON_CALENDAR_LABEL = 'Not on calendar';

/**
 * Neutral pill shown on meetings Ahoy synthesized from notes for an ad hoc call that was never on
 * a calendar. Presentation only - gray, NOT a warning: the meeting is real, its calendar event is
 * simply absent. Callers gate on `isMeetingAdHoc(object)`; this renders only the pill. Matches the
 * `recurringBadge` shape in meeting-sub-header.tsx (dark mode + tokens handled by base Badge).
 */
export function NotOnCalendarBadge() {
  return (
    <Badge type='pill-color' color='gray' size='sm'>
      {NOT_ON_CALENDAR_LABEL}
    </Badge>
  );
}
